//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dicOption, colorOption } from '@/option/config';
export default {
  inject: ["main"],
  data: function data() {
    return {
      dicOption: dicOption,
      colorOption: colorOption
    };
  },
  methods: {
    rowSave: function rowSave(row, done) {
      this.main.activeOption.barColor.push(row);
      done();
    },
    rowDel: function rowDel(row, index) {
      this.main.activeOption.barColor.splice(index, 1);
    },
    rowUpdate: function rowUpdate(row, index, done) {
      this.main.activeOption.barColor.splice(index, 1, row);
      done();
    }
  }
};